import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/fe';

/**
 * @class SafeAssetPathPipe
 * @description Pipe for transforming relative asset URLs to absolute static URLS to be used in widget integration
 * */
@Pipe({
  name: 'safeAssetPath',
  standalone: false,
})
export class SafeAssetPathPipe implements PipeTransform {
  transform(path: string): string {
    const isLocal = environment.name.includes('local');
    const isNotEmbedded = window.location.hostname.endsWith('twaice.cloud') || window.location.hostname.endsWith('twaice.ai');
    if (isLocal || isNotEmbedded) {
      return path;
    }

    return `${environment.staticFilesHost}widgets/fleet-analytics/latest/${path}`;
  }
}
